import { Box, Dialog, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ButtonStd } from '../ui/ButtonStd';
import CardSection from '../ui/CardSection';
import CardTitle from '../ui/CardTitle';
import HandleTop from '../ui/HandleTop';
import InputStd from '../ui/InputStd';
import WindowBackground from '../ui/WindowBackground';

const ProjectSettingsModal = ({ open, onClose, project, isOwner, onUpdate, onDelete }) => {
  const [name, setName] = useState(project?.name || '');
  const [description, setDescription] = useState(project?.description || '');

  React.useEffect(() => {
    setName(project?.name || '');
    setDescription(project?.description || '');
  }, [project]);

  const handleSave = async () => {
    await onUpdate?.({ name: name.trim(), description: description.trim() || null });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      slotProps={{ paper: { sx: { background: 'transparent', boxShadow: 'none' } } }}
    >
      <Box
        sx={{
          width: 600,
          display: 'flex',
          flexDirection: 'column',
          gap: '1px',
          borderRadius: '16px',
          backgroundColor: 'rgba(102, 111, 116, 0.6)',
          boxShadow: '0 24px 24px 0 rgba(67, 79, 86, 0.21)',
        }}
      >
        <HandleTop onIconClick={onClose} iconAriaLabel="Close" />
        <WindowBackground radius="20px">
          <CardTitle title="Project Settings">
            <Stack spacing={1.5}>
              <InputStd
                label="Name"
                value={name}
                onChange={(val) => setName(val)}
                align="left"
                disabled={!isOwner}
                variant={isOwner ? 'input' : 'output'}
              />
              <InputStd
                label="Description"
                value={description}
                onChange={(val) => setDescription(val)}
                align="left"
                disabled={!isOwner}
                variant={isOwner ? 'input' : 'output'}
              />

              <CardSection title="Info">
                <Stack spacing={0.5}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 1 }}>
                    <Typography sx={{ color: '#7d8d97', fontSize: 12 }}>Project ID</Typography>
                    <Typography sx={{ color: '#394b57', fontSize: 12, fontFamily: 'monospace' }}>
                      {project?.project_id}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 1 }}>
                    <Typography sx={{ color: '#7d8d97', fontSize: 12 }}>Created</Typography>
                    <Typography sx={{ color: '#394b57', fontSize: 12 }}>
                      {project?.created_at
                        ? new Date(project.created_at).toLocaleDateString('en-GB', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                          })
                        : '—'}
                    </Typography>
                  </Box>
                  {(project?.creator_display_name || project?.creator_username) && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 1 }}>
                      <Typography sx={{ color: '#7d8d97', fontSize: 12 }}>Owner</Typography>
                      <Typography sx={{ color: '#394b57', fontSize: 12 }}>
                        {project.creator_display_name || project.creator_username}
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </CardSection>

              {isOwner && (
                <CardSection title="Danger Zone">
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Box>
                      <Typography sx={{ color: '#394b57', fontSize: 13, fontWeight: 500 }}>
                        Delete Project
                      </Typography>
                      <Typography sx={{ color: '#7d8d97', fontSize: 11 }}>
                        Permanently remove. Cannot be undone.
                      </Typography>
                    </Box>
                    <ButtonStd
                      height="32px"
                      onClick={() => {
                        onDelete?.();
                        onClose();
                      }}
                    >
                      Delete
                    </ButtonStd>
                  </Stack>
                </CardSection>
              )}

              <Stack direction="row" spacing={1} justifyContent="center">
                {isOwner ? (
                  <>
                    <ButtonStd height="40px" onClick={onClose}>
                      Cancel
                    </ButtonStd>
                    <ButtonStd height="40px" onClick={handleSave} disabled={!name.trim()}>
                      Save Changes
                    </ButtonStd>
                  </>
                ) : (
                  <ButtonStd height="40px" onClick={onClose}>
                    Close
                  </ButtonStd>
                )}
              </Stack>
            </Stack>
          </CardTitle>
        </WindowBackground>
      </Box>
    </Dialog>
  );
};

export default ProjectSettingsModal;
